import { defineMessages } from 'react-intl';

export default defineMessages({
    editCoverage: {
        id: 'ml.common.component.MLReadOnlyCoverage.editCoverage',
        defaultMessage: 'EDIT COVERAGE'
    },
    coverages: {
        id: 'ml.common.component.MLReadOnlyCoverage.coverages',
        defaultMessage: 'Coverages'
    },
    limits: {
        id: 'ml.common.component.MLReadOnlyCoverage.limits',
        defaultMessage: 'Limits'
    },
    monthlyPremium: {
        id: 'ml.common.component.MLReadOnlyCoverage.monthlyPremium',
        defaultMessage: 'Monthly Premium'
    },
    premium: {
        id: 'ml.common.component.MLReadOnlyCoverage.premium',
        defaultMessage: 'Premium'
    },
    pickYourCoverageLevel: {
        id: 'ml.common.component.MLReadOnlyCoverage.pickYourCoverageLevel',
        defaultMessage: 'Pick your coverage level'
    }
});
